module.exports = __webpack_public_path__ + "static/media/hardlockeng.1674d418.png";